// 首页搜索框
import React from 'react'
import SearchBoxStyle from './styles/SearchBoxStyle'
import { withStyles } from '@zn-material-ui'
import home_icon_searchImage from '@images/homepage/home_icon_searchImage.png'
import { inject, observer } from 'mobx-react'
import { withSnackbar, withSnackbarProps } from 'notistack'
import { last, split } from 'lodash'
import Store from 'store'
import { transform } from '@utils/intl_lang'
import { getUrlParam } from '@utils'

export interface IProps extends withSnackbarProps {
  classes: any
  history: any
  Search: any
  routeParam: any
  disabled: boolean
}
@inject('UserStore', 'Search')
@observer
class SearchBox extends React.Component<IProps, any> {
  private input: any
  constructor(props: any) {
    super(props)
    this.input = React.createRef()
    this.state = {
      searchWord: decodeURIComponent(getUrlParam('searchWord') || ''),
      routeParam: 'search',
      dataList: [],
      pageNumber: 1,
      loading: false,
      haveMore: true,
      dataArr: [],
      index: -1,
    }
  }

  public valueChange = (e: any) => {
    this.setState({ searchWord: e.target.value })
    this.props.Search.updateSearchWord(e.target.value)
  }

  public handleEnterKey = (e: any) => {
    if (e.nativeEvent.keyCode === 13) {
      // e.nativeEvent获取原生的事件对像
      this.onSearch()
    }
  }

  // 获取当前路由/后的最后一个值
  // public getRoute = (route: string) => {
  //   const index = route.lastIndexOf("/")
  //   return route = route.substring(index + 1)
  // }

  public onSearch = () => {
    const val = this.input.value
    if (!val.trim()) {
      return
    }
    this.props.Search.updateSearchWordAfter(this.props.Search.searchWord)
    this.props.Search.updateRouteParam('search')
    this.props.history.push({ pathname: `/home/search` })
    this.props.Search.getAllList()
    // const routeCurrent = this.getRoute(window.location.href)
    // switch (routeCurrent) {
    //   case 'Search':
    //     // 清空原有的mobox的数据
    //     this.props.Search.updateDataList([])
    //     this.props.Search.getAllList()
    //     break
    //   case 'liveSearch':
    //     this.props.Searach.updateLiveList([])
    //     this.props.Searach.getLiveList(1)
    //     break
    //   case 'playBackSearch':
    //     this.props.Search.updatePlayBackList([])
    //     this.props.Search.getLiveBackList(1)
    //     break
    //   case 'comCourseSearch':
    //     this.props.Search.updateEnterPriseList([])
    //     this.props.Search.getEnterpriseList(1)
    //     break
    //   case 'subjectSearch':
    //     this.props.Search.updateSeminarList([])
    //     this.props.Search.getSeminarList(1)
    //     break
    //   case 'trainingClassSearch':
    //     this.props.Search.updateTrainList([])
    //     this.props.Search.getSeminarList(1)
    //     break
    //   case 'infoSearch':
    //     this.props.Search.updateInforList([])
    //     this.props.Search.getInforList(1)
    //     break
    //   default:
    //     this.props.history.push({ pathname: `/home/search` })
    //     this.props.Search.getAllList()
    // }
  }


  public render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <input
          className={classes.input}
          type="text"
          // "请输入搜索关键字/直播ID/短视频ID"
          placeholder={transform('enter_search_keywords')}
          title={transform('enter_search_keywords')}
          defaultValue={this.state.searchWord}
          onChange={this.valueChange}
          onKeyPress={this.handleEnterKey}
          ref={input => (this.input = input)}
          disabled={this.props.disabled}
        />
        <div className={classes.searchImg} onClick={this.onSearch}>
          <img alt="xtb" src={home_icon_searchImage} />
          {/* 搜索 */}
          <span>{transform('search')}</span>
        </div>
      </div>
    )
  }
}
// export default withStyles(SearchBoxStyle)(withSnackbar(SearchBox));
export default withStyles(SearchBoxStyle)(withSnackbar(SearchBox))
